import { Prop, toNative } from 'vue-facing-decorator';
import TsxComponent, { Component } from '../../app/vuetsx';

interface HtmlLiteralArgs {
	innerHTML: string;
	wrapAsDiv?: boolean;
	cssClass?: string;
}

@Component
class HtmlLiteralComponent extends TsxComponent<HtmlLiteralArgs> implements HtmlLiteralArgs {
	@Prop() innerHTML!: string;
	@Prop() wrapAsDiv: boolean;
	@Prop() cssClass?: string;

	render(h) {
		if (this.innerHTML != null) {
			if (!this.wrapAsDiv) {
				return <span class={this.cssClass} innerHTML={this.innerHTML}></span>;
			} else {
				return <div class={this.cssClass} innerHTML={this.innerHTML}></div>;
			}
		}
	}
}

const HtmlLiteral = toNative(HtmlLiteralComponent);
export default HtmlLiteral;
